import type {ReactNode} from 'react'
import {CardHeader} from '@/components/ui/card'
import {cn} from '@/lib/utils'

interface RowCardHeaderProps {
    children: ReactNode
    className?: string
}

export function RowCardHeader({children, className}: RowCardHeaderProps) {
    return (
        <CardHeader className={cn('flex flex-row items-center justify-between space-y-0', className)}>
            {children}
        </CardHeader>
    )
}
